import store from '@/store';
export default {
    height: "auto",
    calcHeight: 30,
    tip: false,
    searchShow: true,
    searchSpan: 6,
    searchMenuSpan: 6,
    border: true,
    index: true,
    menuWidth: 190,
    viewBtn: false,
    editBtn: false,
    delBtn: false,
    addBtn: false,
    selection: false,
    dialogClickModal: false,
    searchLabelWidth: 100,
    overflowHidden: true,
    column: [{
            label: "主键id",
            prop: "id",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
        },
        {
            label: "进件编号",
            prop: "businessCode",
            type: "input",
            search: true,
            searchOrder: 500,
            minWidth: 130,
        },
        {
            label: "所属代理商",
            prop: "businessDeptName",
            type: "input",
            minWidth: 130,
        },
        {
            label: "产品类型",
            prop: "rentType",
            type: "select",
            minWidth: 130,
            dicData: store.getters.porductTypes
        },
        {
            label: "产品类型",
            prop: "rentTypeList",
            type: "select",
            search: true,
            searchOrder: 498,
            minWidth: 130,
            searchMultiple: true,
            hide: true,
            showColumn: false,
            dicData: store.getters.porductTypes
        },
        {
            label: "租赁人",
            prop: "name",
            type: "input",
            search: "true",
            searchOrder: 447,
            minWidth: 130,
        },
        {
            label: "手机号",
            prop: "phoneNumber",
            type: "input",
            search: true,
            searchOrder: 497,
            minWidth: 120,

        },
        {
            label: "租赁金额",
            prop: "lendingAmount",
            type: "input",
            minWidth: 120,
        },
        {
            label: "每月租金",
            prop: "lendingAmountPer",
            type: "input",
            minWidth: 120,
        },
        // {
        //     label: "结清金额",
        //     prop: "settlementAmount",
        //     type: "input",
        //     minWidth: 120,
        //     hide:true
        // },
        {
            label: "投诉结清金额",
            prop: "settlementAmount",
            minWidth: 120,
            type: "input",
            hide:false
        },
        {
            label: "所属代理商",
            prop: "businessDeptIdList",
            type: "select",
            filterable: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
            searchMultiple: true,
            searchClearable: true,
            defaultExpandAll: true,
            searchOrder: 499,
            hide: true,
            dicData: [],
            props: {
                label: "title",
                value: "id",
            },
        },
        {
            label: "车牌号",
            prop: "carFirstNumber",
            type: "input",
            minWidth: 110,
            search: true,
            searchOrder: 496,
        },
        {
            label: "提交时间",
            prop: "logCreateTime",
            type: "date",
            minWidth: 190,
            // search: true,
            searchRange: true,
            // hide: true,
            showColumn: false,
            searchType: "daterange",
            valueFormat: "yyyy-MM-dd",
        },
    ]
};
